// extracted by mini-css-extract-plugin
export default {"divShake":"PurchaseDiv_divShake__y1LNE","horizontal-shaking":"PurchaseDiv_horizontal-shaking__UAjQT"};